import { z } from 'zod';
/**
 * 超商品牌枚舉
 */
export const ConvenienceStoreBrandSchema = z.enum([
    '7-ELEVEN',
    'FamilyMart',
    'HiLife',
    'OK_MART',
]);
/**
 * 超商門市資訊 Schema
 */
export const ConvenienceStoreInfoSchema = z.object({
    brand: ConvenienceStoreBrandSchema.describe('超商品牌'),
    store_id: z.string().min(1).describe('門市代碼'),
    store_name: z.string().min(1).describe('門市名稱'),
    store_address: z.string().min(1).describe('門市地址'),
    store_phone: z.string().optional().describe('門市電話'),
});
/**
 * 地址快照 Schema
 * 用於 shipments.addressSnapshot，儲存出貨時的地址資訊快照
 * 即使客戶地址後來變更，出貨單仍保留當時的地址資訊
 * 支援一般地址和超商門市資訊
 */
export const AddressSnapshotSchema = z
    .object({
    name: z.string().min(1).describe('收件人姓名'),
    phone: z.string().optional().describe('收件人電話'),
    address_line1: z
        .string()
        .min(1)
        .optional()
        .describe('地址第一行（街道地址，宅配時必填）'),
    address_line2: z.string().optional().describe('地址第二行（樓層、室號等）'),
    city: z.string().min(1).optional().describe('城市（宅配時必填）'),
    district: z.string().optional().describe('區/鄉鎮'),
    postal_code: z.string().optional().describe('郵遞區號'),
    country: z.string().default('Taiwan').describe('國家（預設：Taiwan）'),
    // 超商門市資訊（超商取貨時使用）
    convenience_store: ConvenienceStoreInfoSchema.optional().describe('超商門市資訊（超商取貨時必填）'),
})
    .passthrough() // 允許額外欄位以支援未來擴展
    .nullable()
    .optional()
    .describe('地址快照（JSONB 格式）');
